import { render, staticRenderFns } from "./TransferFilterDialogForCustomerService.vue?vue&type=template&id=51277b06&"
import script from "./TransferFilterDialogForCustomerService.vue?vue&type=script&lang=js&"
export * from "./TransferFilterDialogForCustomerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports